import { render, staticRenderFns } from "./microShopGoodsList.vue?vue&type=template&id=1fa65338&scoped=true&"
import script from "./microShopGoodsList.vue?vue&type=script&lang=js&"
export * from "./microShopGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./microShopGoodsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./microShopGoodsList.vue?vue&type=style&index=1&id=1fa65338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa65338",
  null
  
)

component.options.__file = "microShopGoodsList.vue"
export default component.exports